const buyer = [
  { label: "Dashboard", icon: "icon ni ni-growth", url: "/buyer/dashboard" },
  {
    label: "Orders",
    icon: "icon ni ni-table-view",
    url: "/buyer/orders",
  },
];

export default buyer;
